'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('voting-show-ss', {
      url: '/voting/ss/:id',
      template: '<voting-show-ss></voting-show-ss>',
      authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/voting/voting-show-ss/voting-show-ss.routes.js